import { getRelativeTime } from "../utility/formatter-helper";
import { useEffect, useState } from "react";

export const useRelativeTime = (date = "") => {
  const [relativeTime, setRelativeTime] = useState(() => getRelativeTime(date));

  useEffect(() => {
    if (!date) return;

    const interval = setInterval(() => {
      setRelativeTime(getRelativeTime(date));
    }, 1000); // Update every second

    return () => clearInterval(interval);
  }, [date]);

  return date ? relativeTime : "";
};
